import store from "../../Store/configureStore";
import { strToFloat } from "../../Util/util";
const lodash = require("lodash");

/**
 * Given a role (str), returns an object from store that describes the role.
 */
export const getInfoForRole = (roleStr) => {
  const state = store.getState();
  const retrainCostDetails = state.costs.retrainCostDetails;
  const roleDetails = retrainCostDetails.roles.find((item) => item.role === roleStr);
  return roleDetails;
};

/**
 * Given a role (str), returns the sub total re-train cost.
 */
export const getRetrainCostForRole = (roleStr) => {
  const roleDetails = getInfoForRole(roleStr);
  const wage = lodash.get(roleDetails, "wage");
  const benefit = lodash.get(roleDetails, "benefit");
  let number = lodash.get(roleDetails, "number");
  let hours = lodash.get(roleDetails, "hours");

  if (!number || number < 0){number = 0}
  if (!hours || hours < 0){hours = 0}

  return (strToFloat(wage) + strToFloat(benefit)) * strToFloat(number) * strToFloat(hours);
};

/**
 * Returns the total retrain cost.
 */
export const getTotalRetrainCost = () => {
  const state = store.getState();

  const roleCosts = state.costs.retrainCostDetails.roles.map((element) => getRetrainCostForRole(element.role));
  const roleTotal = roleCosts.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const commonCostNames = Object.keys(state.costs.retrainCostDetails).filter((item) => item !== "roles");
  const commonCosts = commonCostNames.map((element) => strToFloat(state.costs.retrainCostDetails[element]));
  const commonCostTotal = commonCosts.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  return commonCostTotal + roleTotal;
};

/**
 * Calculates wage plus benefits for a given role (str)
 */
export const getWagePlusBenefitsForRole = (roleStr) => {
  const roleDetails = getInfoForRole(roleStr);
  let wage = lodash.get(roleDetails, "wage");
  let benefit = lodash.get(roleDetails, "benefit");

  if (!wage){wage = 0}
  if (!benefit){benefit = 0}

  return strToFloat(wage) + strToFloat(benefit);
};
